import { LinkTypes } from '@storyblok/richtext';
import { Mark, mergeAttributes } from '@tiptap/core';

// Creates a tiptap Mark extension that prepends internal links with a base URL
export function createPrependInternalLinkExtension(prependLink: string) {
	return Mark.create({
		name: 'link',
		addAttributes() {
			return {
				href: { default: null },
				linktype: { default: null },
				anchor: { default: null },
				target: { default: null },
				uuid: { default: null },
			};
		},
		renderHTML({ HTMLAttributes }) {
			const { linktype, href, anchor, ...rest } = HTMLAttributes;

			let finalHref: string;
			switch (linktype) {
				case LinkTypes.ASSET:
				case LinkTypes.URL:
					finalHref = href;
					break;
				case LinkTypes.EMAIL:
					finalHref = `mailto:${href}`;
					break;
				case LinkTypes.STORY:
					finalHref = prependLink + href;
					if (anchor) {
						finalHref = `${finalHref}#${anchor}`;
					}
					break;
				default:
					finalHref = href;
					break;
			}
			const attributes: Record<string, unknown> = { ...rest };
			if (finalHref) {
				attributes['href'] = finalHref;
			}
			return ['a', mergeAttributes(attributes), 0];
		},
	});
}
